// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Message-notification-NAN1d {
  background: var(--alert-color);
  border-radius: 50%;
  height: 5px;
  width: 5px;
  position: absolute;
  top: 12px;
  -webkit-transform: translate3d(4px, -8px, 0);
          transform: translate3d(4px, -8px, 0);
}

@media screen and (max-width: 1199px) {
  .Message-notification-NAN1d {
    top: 24px;
    -webkit-transform: translate3d(1px, -8px, 0);
    transform: translate3d(1px, -8px, 0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Message/Message.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,4CAAoC;UAApC,oCAAoC;AACtC;;AAEA;EACE;IACE,SAAS;IACT,4CAA4C;IAC5C,oCAAoC;EACtC;AACF","sourcesContent":[".notification {\n  background: var(--alert-color);\n  border-radius: 50%;\n  height: 5px;\n  width: 5px;\n  position: absolute;\n  top: 12px;\n  transform: translate3d(4px, -8px, 0);\n}\n\n@media screen and (max-width: 1199px) {\n  .notification {\n    top: 24px;\n    -webkit-transform: translate3d(1px, -8px, 0);\n    transform: translate3d(1px, -8px, 0);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notification": `Message-notification-NAN1d`
};
module.exports = ___CSS_LOADER_EXPORT___;
